import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send/receive httpOnly session cookies (F5)
});

function getCookie(name) {
  const match = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return match ? decodeURIComponent(match.pop()) : null;
}

// CSRF double-submit: echo the readable csrf_token cookie as a header on
// state-changing requests so the cookie-authenticated session is protected.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const csrf = getCookie("csrf_token");
    if (csrf) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = csrf;
    }
  }
  return config;
});

// Safety net: if a state-changing request is rejected for a missing/invalid CSRF
// token, retry it once with a freshly-read token (handles first-interaction races).
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const status = error.response && error.response.status;
    const detail = error.response && error.response.data && error.response.data.detail;
    if (status === 403 && cfg && !cfg._csrfRetried &&
        typeof detail === "string" && detail.toLowerCase().includes("csrf")) {
      const csrf = getCookie("csrf_token");
      if (csrf) {
        cfg._csrfRetried = true;
        cfg.headers = cfg.headers || {};
        cfg.headers["X-CSRF-Token"] = csrf;
        return api.request(cfg);
      }
    }
    return Promise.reject(error);
  }
);

// Friendly error extraction
export function errMsg(err, fallback = "Une erreur est survenue.") {
  if (!err) return fallback;
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return err?.message || fallback;
}

export default api;
